module.exports = __webpack_public_path__ + "img/user2.eff0ef70.png";